import { useState } from "react";
import searchIcon from "../../../../../assets/icons/search.svg";
import { HistoricoCard } from "./components/historico-card";
import { ClienteInfo } from "../cliente-info";
import { useHistorico } from "../../../../../context/HistoricoContext";
import { useDividas } from "../../../../../context/DividasContext";
import { format } from "date-fns";
import { useModal } from "../../../../../hooks/ModalContext";
import { BsPlusSquare, BsPlusSquareFill } from "react-icons/bs";
import { GenericModal } from "../../../../Modal";
import { useAuth } from "../../../../../context/AuthContext";

interface HistoricoProps {
  app?: string;
}

export const Historico = ({ app }: HistoricoProps) => {
  const [dataInicio, setDataInicio] = useState('')
  const [dataFim, setDataFim] = useState('')


  const { devedor, selectedCredor, } = useDividas()
  const { setModal, modalInfo, onClose } = useModal()
  const { historico, getHistorico } = useHistorico()
  const { cookies } = useAuth()


  async function filtro() {
    await getHistorico({ url: selectedCredor?.url_ws, cpf_cnpj: devedor?.cpf_cnpj, codcredor: String(selectedCredor?.credor_crm), dataFim: format(new Date(dataFim), 'dd/MM/yyyy'), dataInicio: format(new Date(dataInicio), 'dd/MM/yyyy'), app, usuario: String(cookies?.user?.id_operador), })
  }

  return (
    <div className="px-4">
      <ClienteInfo />

      <div>
        <button
          onClick={() => setModal("Tabulação", "Cadastro")}
          className="flex w-[26%] items-center justify-center gap-2 rounded bg-primary text-sm p-2 px-4 my-4 text-white"
        >
          <BsPlusSquare size={18} color="#fff" />
          Adicionar Tabulação
        </button>
      </div>
      <div className="min-h-page flex  w-full items-center justify-between px-4 py-2">

        <div className="input-historico">
          <p className="p-historico">De:</p>
          <input
            type="date"
            value={dataInicio}
            max={dataFim}
            onChange={(e) => setDataInicio(e.target.value)}
            className="w-38 block rounded-md border border-gray-300 bg-gray-50 px-2.5 py-1 text-xs text-gray-500 outline-none "
          />
        </div>
        <div className="input-historico">
          <p className="p-historico">Até:</p>
          <input
            type="date"
            value={dataFim}
            onChange={(e) => setDataFim(e.target.value)}
            min={dataInicio}
            className="w-38 block rounded-md border border-gray-300 bg-gray-50 px-2.5 py-1 text-xs text-gray-500 outline-none "
          />
        </div>
        <div>
          {/* <div className="input-historico">
            <p className="p-historico">Canal:</p>
            <select
              onChange={(e) => setChannel(e.target.value)}
              className="w-38 block rounded-md border border-gray-300 bg-gray-50 px-2.5 py-1 text-sm text-gray-500 outline-none"
            >
              <option value="todos">Todos os canais</option>
              <option value="whatsapp">WhatsApp</option>
              <option value="sms">SMS</option>
              <option value="chatbot">Chatbot</option>
              <option value="ligacao">Ligação</option>
            </select>
          </div> */}
        </div>

        <button type="button" className="flex h-8 w-10 items-center justify-center  rounded-md border-0 bg-primary" onClick={filtro}>
          <img src={searchIcon} alt="" className="h-6 w-6" />
        </button>
      </div>

      <div className="max-h-[400px] overflow-y-scroll rounded-md border border-gray-300 px-2 ">
        {
          historico?.acionamentos && historico?.acionamentos?.acionamento?.length > 0 && historico.acionamentos?.acionamento.map(acio => (
            // <div key={acio.id_poscob}>
            <HistoricoCard acionamento={acio} />
            // </div>
          ))
        }
        {/* <p></p> */}
      </div>

      <GenericModal
        title={modalInfo.title}
        type={modalInfo.type}
        onClose={() => onClose()}
        show={modalInfo.isOpen && modalInfo.title === "Tabulação"}
        modalType="Tabulação"
        isOperador
        app={app}
      />

    </div>
  );
};
